export const DESKTOP_PERFORMANCE_MODE_STORAGE_KEY = 'khal:desktop:performance-mode';
export const DESKTOP_PERFORMANCE_MODE_ENV_KEY = 'VITE_KHAL_DESKTOP_PERFORMANCE_MODE';

export type DesktopPerformanceMode = 'on' | 'off';

function normalizePerformanceMode(value: unknown): DesktopPerformanceMode | undefined {
	if (typeof value !== 'string') return undefined;
	const normalized = value.trim().toLowerCase();
	if (normalized === 'off' || normalized === 'false' || normalized === '0' || normalized === 'disabled') return 'off';
	if (normalized === 'on' || normalized === 'true' || normalized === '1' || normalized === 'enabled') return 'on';
	return undefined;
}

export function resolveDesktopPerformanceMode({
	envValue,
	storedValue,
}: {
	envValue?: string | null;
	storedValue?: string | null;
}): DesktopPerformanceMode {
	// localStorage wins so ops can roll this emergency diet back without a rebuild:
	// localStorage.setItem('khal:desktop:performance-mode', 'off')
	return normalizePerformanceMode(storedValue) ?? normalizePerformanceMode(envValue) ?? 'on';
}

export function readDesktopPerformanceModeFromBrowser(envValue?: string | null): DesktopPerformanceMode {
	let storedValue: string | null | undefined;
	try {
		storedValue = typeof window !== 'undefined' ? window.localStorage.getItem(DESKTOP_PERFORMANCE_MODE_STORAGE_KEY) : undefined;
	} catch {
		storedValue = undefined;
	}
	return resolveDesktopPerformanceMode({ envValue, storedValue });
}

export function applyDesktopPerformanceMode(mode: DesktopPerformanceMode, targetDocument: Document = document) {
	targetDocument.documentElement.dataset.desktopPerformance = mode;
}
